import React, { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router'
import { Container, Row } from 'reactstrap';
import BreadcrumbWithFilter from 'src/components/Common/BreadcrumbWithFilter/BreadCrumbWithFilter'
import { ROUTER } from 'src/constants/routes'
import { useDispatch, useSelector } from 'react-redux'
import { RootReducerState } from 'src/store/reducers'
import { getBulkEmailById } from 'src/store/BulkEmail/action'
import { TabPanel, TabView } from 'primereact/tabview'
import FeatherIcon from "feather-icons-react";
import { getNotificationById } from 'src/store/notification/action';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

const ViewNotification = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const { notificationDetails,error, message , loading } = useSelector((state: RootReducerState) => state.NotificationReducer);

  useEffect(() => {
    dispatch(getNotificationById(id));
  }, []);

  const BulkEmailDetails = [
    {
      name: "Content",
      value: notificationDetails?.content ? <div style={{whiteSpace:"wrap"}}>{notificationDetails?.content}</div> : ""
    },
    {
      name: "Sent Count",
      value: notificationDetails?.sendCount ? notificationDetails?.sendCount : ""
    },
    {
      name: "Failure Count",
      value: notificationDetails?.failureCount ? notificationDetails?.failureCount  : 0
    },
    {
      name: "Status",
      value: notificationDetails?.status ? notificationDetails?.status  : 0
    },
  ]

  const SentMailHeader = (options:any) => {
    return (
        <div className="flex align-items-center gap-2 p-3" style={{ cursor: 'pointer' }} onClick={options.onClick}>
            <FeatherIcon icon="send" className="mr-1 view-bulk-mail-icon text-success" />
            <span className="font-bold white-space-nowrap d-none-sm">Sent Notification</span>
        </div>
    );
};
  const FailureMailHeader = (options:any) => {
    return (
        <div className="flex align-items-center gap-2 p-3" style={{ cursor: 'pointer' }} onClick={options.onClick}>
            <FeatherIcon icon="thumbs-down" className="mr-1 view-bulk-mail-icon text-danger" />
            <span className="font-bold white-space-nowrap">Failure Notification</span>
        </div>
    );
};
  return (
    <React.Fragment>
      <div className="pagecontent" id='pagecontent'>
        <Container fluid>
          <BreadcrumbWithFilter
            title="Notification"
            titlePath={ROUTER.NOTIFICATION_LIST}
            breadcrumbItem="Notification Details"
            isShowCreate={false}
            isShowFilter={false}
            filter={false}
          />
<Row>
    <div className="view">
            <div className="general-details">
              <b>Notification Details</b>
            </div>
            <div className="subview">
            <div className="parentCls">
            {
              BulkEmailDetails?.map((data, index) => {
                return (
                  <div key={index} className={` pt-2 childCls`}>
                    <div>{data.name}</div>
                    <div>{data.value?data.value:<div className="none-text">-</div>}</div>
                  </div>
                )
              })
            }
          </div>
        </div>
        </div>
    </Row>

    <Row>
        <div className="view" id="bulkEmail">
            <TabView >
                
                  <TabPanel header="Sent Email Id's"  headerTemplate={SentMailHeader}>
                <div className='d-flex gap-3 flex-wrap'>
                    {
                       
                    notificationDetails?.sendNotificationStatusListDtos?.filter((val:any)=>val.isSent == true)?.map((data:any,index:any,arr:any)=>{
                        return(
                             <b key={index}>{`${data.name}${arr?.length < 2 ? "" : index+1 == (arr?.length) ? "." : ","}`}</b>
                        )
                    })
                    }
                </div>
                  </TabPanel>
                <TabPanel header="Failure Email Id's"  headerTemplate={FailureMailHeader} style={{maxHeight:"auto"}}>
                <div className='d-flex gap-3 flex-wrap'>
                    {
                         <div className="card ps-0 pe-0 mt-2" id="table-border">
                         <DataTable  size='large' value={notificationDetails?.sendNotificationStatusListDtos?.filter((val:any)=>val.isSent == false)} showGridlines
                         className='mailTable'
                         style={{minWidth:"50vw"}}
                            scrollHeight='350px'
                            scrollable
                            >
                             <Column
                               header="S.No"
                               body={(rowData, { rowIndex }) => rowIndex + 1}
                               style={{ width: '70px' }}
                             />
                             <Column field="name" header="Name" className=''></Column>
                             <Column field="failureReason" header="Failure Reason" className=''></Column>
                             </DataTable>
                        </div>
                    }
                </div>
                  </TabPanel>

                  </TabView>
            </div>
           
    </Row>
 
        </Container>
      </div>
    </React.Fragment>
  )
}

export default ViewNotification